<h2 mat-dialog-title>
  Sales Hint</h2>
<mat-dialog-content fxLayout="column">
  {{data.salesHint}}
</mat-dialog-content>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end end" style="margin-right:-8px;padding-bottom:8px;">
  <button mat-button color="primary" (click)="onCancel()">OK</button>
</div>